import React from "react";
import { selectDateOptionsNew } from "./DatesOptions";

export const getDateBeginDateEnd = (selectedOption) => {
  //let selectedOption;
  let periodType;
  let periodQty;
  let DateBegin;
  let DateEnd;

  //si on a selectedOption

  if (selectedOption) {
    //console.log('selectedOption');
    if (selectedOption === selectDateOptionsNew[0].value) {
      periodType = "Y";
      periodQty = "0";
    } else if (selectedOption === selectDateOptionsNew[1].value) {
      periodType = "M";
      periodQty = "0";
    } else if (selectedOption === selectDateOptionsNew[2].value) {
      periodType = "y";
      periodQty = "1";
    } else if (selectedOption === selectDateOptionsNew[3].value) {
      periodType = "y";
      periodQty = "2";
    } else if (selectedOption === selectDateOptionsNew[4].value) {
      periodType = "Y";
      periodQty = "1";
    } else if (selectedOption === selectDateOptionsNew[5].value) {
      periodType = "Y";
      periodQty = "2";
    } else if (selectedOption === selectDateOptionsNew[6].value) {
      periodType = "YF";
      periodQty = "2";
    }
    //return {periodType, periodQty};
  }

  /**
   *  * on va maintenant traiter la date
   * **/
  function add_months(date, number) {
    return new Date(date.setMonth(date.getMonth() + number));
  }

  function add_days(date, number) {
    return new Date(date.setDate(date.getDate() + number));
  }

  //traitement des dates
  if (periodType && periodQty) {
    if (periodType !== "" && periodQty !== "") {
      let dateEnd = new Date();
      dateEnd.setHours(0);
      dateEnd.setMinutes(0);
      dateEnd.setSeconds(0);

      let dateBegin = new Date();

      if (periodType === "y") {
        //x years reculer d x année glissante
        dateEnd.setDate(1); //1er du mois
        dateEnd = add_months(dateEnd, 1); //1er du mois suivant
        dateEnd = add_days(dateEnd, -1); //dernier jour du mois
        dateBegin.setTime(dateEnd.getTime());
        dateBegin = add_months(dateBegin, -12 * periodQty);
        dateBegin.setMinutes(0);
        dateBegin.setSeconds(0);
        dateBegin.setDate(1);
      } else if (periodType === "Y") {
        //beginning of year x years ago - end of year x years ago année dernière ou il y a deux ans
        dateBegin.setTime(dateEnd.getTime());
        dateBegin = add_months(dateBegin, -12 * periodQty);
        dateBegin.setMonth(0);
        dateBegin.setMinutes(0);
        //add setHours
        dateBegin.setSeconds(0);
        dateBegin.setDate(1);

        dateEnd = add_months(dateEnd, -12 * periodQty);
        dateEnd.setMonth(11);
        dateEnd.setDate(31);
      } else if (periodType === "YF") {
        //beginning of year x years ago - end of last year //année dernière et précédente
        dateBegin.setTime(dateEnd.getTime());
        dateBegin = add_months(dateBegin, -12 * periodQty);
        //dateBegin = add_months(dateBegin, -12 * periodQty);
        dateBegin.setMonth(0);
        dateBegin.setMinutes(0);
        dateBegin.setSeconds(0);
        dateBegin.setDate(1);

        dateEnd = add_months(dateEnd, -12);
        dateEnd.setMonth(11);
        dateEnd.setDate(31);
        //2019-01-01 - 31-12-2020
      }
      else if (periodType === 'M') //beginning of month x months ago
      {
        dateEnd = add_months(dateEnd, 1);
        dateEnd.setDate(1);
        dateEnd = add_days(dateEnd, -1); //dernier jour du mois en cours
        dateBegin.setTime(dateEnd.getTime());
        dateBegin = add_months(dateBegin, -1 * periodQty);
        dateBegin.setMinutes(0);
        dateBegin.setSeconds(0);
        dateBegin.setDate(1);
      }
      /*  if (periodType === 'm') //x months
              {
                  dateEnd = add_seconds(dateEnd, -1); //dernier jour
                  dateBegin.setTime(dateEnd.getTime());
                  dateBegin = add_months(dateBegin, -1 * periodQty);
                  dateBegin.setMinutes(0);
                  dateBegin.setSeconds(0);
                  ;
              } else if (periodType === 'M') //beginning of month x months ago
              {
                  dateEnd.setDate(1);
                  dateEnd = add_seconds(dateEnd, -1); //dernier jour du mois précédent
                  dateBegin.setTime(dateEnd.getTime());
                  dateBegin = add_months(dateBegin, -1 * periodQty);
                  dateBegin.setMinutes(0);
                  dateBegin.setSeconds(0);
                  dateBegin.setDate(1);
              }
              if (periodType === 'd') //x days
              {
                  //dateEnd = add_seconds(dateEnd,-1); //dernier jour
                  dateEnd = new Date();
                  dateEnd = add_days(dateEnd, 1);
                  dateBegin.setTime(dateEnd.getTime());
                  dateBegin = add_days(dateBegin, -1 * periodQty);
                  dateBegin.setMinutes(0);
                  dateBegin.setSeconds(0);
              }*/
      //
      const yearEnd = "" + (dateEnd.getYear() + 1900);
      const monthEnd = ("0" + (dateEnd.getMonth() + 1)).slice(-2);
      const dayEnd = ("0" + dateEnd.getDate()).slice(-2);
      //dateEnd = yearEnd + "-" + monthEnd + "-" + dayEnd;

      const yearBegin = "" + (dateBegin.getYear() + 1900);
      const monthBegin = ("0" + (dateBegin.getMonth() + 1)).slice(-2);
      const dayBegin = ("0" + dateBegin.getDate()).slice(-2);
      //dateBegin = yearBegin + "-" + monthBegin + "-" + dayBegin;

      DateBegin = yearBegin + "-" + monthBegin + "-" + dayBegin;
      DateEnd = yearEnd + "-" + monthEnd + "-" + dayEnd;

      //console.log("DateBegin", DateBegin);
      // console.log("DateEnd", DateEnd);

      //return {DateBegin :DateBegin, DateEnd:DateEnd};
    }
  }

  return { DateBegin, DateEnd };
};
